import React from 'react'
import SkuStore from '@/stores/sku';
import DrawerStore from '@/stores/drawer';
import PageStore from '@/stores/page';
import doLog from '@/common/log';

interface PropType {
  type: SkuTypes.TypeInfo
  i18n: DetailTypes.i18n
  showType: string
  attr: SkuTypes.SkuAttr[]
  skuAttrs: SkuTypes.SkuAttr[]
}

export default function TitleTotal(props: PropType) {
  const { type, i18n, attr, skuAttrs = [], showType } = props;

  const skuStore = SkuStore((state) => state);
  const { dialogShow } = DrawerStore((state) => state);
  const secondScreen = PageStore((state) => state.secondScreen);

  const skuInfo = skuStore[type];
  const { quantity = 0 } = skuInfo;

  const renderState = () => {
    if (skuInfo.isSoldOut) {
      return i18n['detail_pc_sku_view_now']
    }
    if (quantity > 0) {
      return i18n['detail_pc_sku_edit_now']
    }
    return i18n['detail_pc_sku_select_now']
  }

  const renderTotal = () => {
    if (quantity > 0) {
      const selectKeys = Object.keys(skuInfo.mapInfo).filter(
        (i) => skuInfo.mapInfo[i].quantity > 0,
      );
      const uniqueContent = skuInfo.attr.map((item, index) => {
        const uniqueArr = [...new Set(selectKeys.map((item) => item.split(';')[index]))];
        return `${uniqueArr.length} ${item.name}`;
      });

      return (
        <div className="item-left">
          <span className="option">{i18n['detail_pc_sku_choosen']} </span>
          <span className="total">{uniqueContent.join('; ')}</span>
        </div>
      );
    }
    // 当用户未选择商品时，展示商品的所有sku选项，如 Total options: 22 Color;4 Size.
    return (
      <div className="item-left">
        <span className="option">{i18n['detail_pc_sku_default_option']} </span>
        <span className="total">
          {attr.map((item, index) => (
            <span key={item.name}>
              {item.values.length} {item.name}
              {index === skuAttrs.length - 1 ? '.' : ';'}
            </span>
          ))}
        </span>
      </div>
    );
  }

  return <>
    <h3>{i18n['detail_pc_sku']}</h3>
    <div className="sku-option">
      {renderTotal()}
      {showType === 'sku' && <div className='item-right'>
        <a href="#" onClick={(e) => {
          e.preventDefault();
          if (showType === 'sku') {
            doLog('/sc.detail.sku.select.now', `second=${secondScreen}`, 'EXP')
            dialogShow({
              type,
            })
          }
        }}>{renderState()}</a></div>}
    </div>
  </>
}
